class ETBundle extends HTMLElement {
  constructor() {
    super();
    this.toggles = this.querySelectorAll('.et-bundle__toggle-input');
    this.selects = this.querySelectorAll('.et-bundle__select');
    this.addButton = this.querySelector('.et-bundle__add-button');
    this.totalCurrent = this.querySelector('.et-bundle__total-current');
    this.totalOriginal = this.querySelector('.et-bundle__total-original');
    this.savingsBadge = this.querySelector('.et-bundle__savings-badge');

    this.init();
  }

  init() {
    // Initialize with first product selected
    this.updateTotals();

    // Add event listeners
    this.toggles.forEach(toggle => {
      toggle.addEventListener('change', () => this.handleToggleChange(toggle));
    });

    this.selects.forEach(select => {
      select.addEventListener('change', (e) => this.handleVariantChange(e));
    });

    this.addButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.handleAddToCart();
    });

    // Listen to product page variant changes
    this.setupProductPageVariantListener();
  }

  setupProductPageVariantListener() {
    // Listen to the product form's variant change
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    const variantInput = productForm.querySelector('input[name="id"]');
    if (!variantInput) return;

    // Use MutationObserver to detect when variant changes
    const observer = new MutationObserver(() => {
      this.updateMainProductVariant();
    });

    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });

    // Also listen to form changes
    productForm.addEventListener('change', () => {
      this.updateMainProductVariant();
    });
  }

  updateMainProductVariant() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    const variantInput = productForm.querySelector('input[name="id"]');
    if (!variantInput) return;

    const selectedVariantId = variantInput.value;

    // Update the main product toggle's variant ID
    const mainProductToggle = this.querySelector('.et-bundle__product-item--main .et-bundle__toggle-input');
    if (mainProductToggle) {
      mainProductToggle.dataset.variantId = selectedVariantId;
      console.log('[Bundle] Updated main product variant to:', selectedVariantId);

      // Update totals with new variant
      this.updateTotals();
    }
  }

  handleToggleChange(toggle) {
    this.updateTotals();
  }

  handleVariantChange(e) {
    const select = e.target;
    const selectedOption = select.options[select.selectedIndex];
    const price = parseFloat(selectedOption.dataset.price);
    const comparePrice = parseFloat(selectedOption.dataset.comparePrice) || 0;

    // Update the displayed selected value
    const wrapper = select.closest('.et-bundle__select-wrapper');
    const selectedValue = wrapper.querySelector('.et-bundle__selected-value');

    const pathname = window.location.pathname;
    let sizeText = 'Maat';
    if (pathname.startsWith('/de/')) {
      sizeText = 'Größe';
    } else if (pathname.startsWith('/fr/')) {
      sizeText = 'Taille';
    }

    selectedValue.textContent = `${sizeText}: ${selectedOption.text}`;

    // Update price display
    const productItem = select.closest('.et-bundle__product-item');
    const card = select.closest('.et-bundle__product-card');
    const priceRow = card.querySelector('.et-bundle__price-row');
    const priceElement = card.querySelector('.et-bundle__price');
    const comparePriceElement = card.querySelector('.et-bundle__compare-price');
    const savingsBadge = card.querySelector('.et-bundle__product-savings');

    priceElement.textContent = this.formatMoney(price);
    priceElement.dataset.price = price;

    if (comparePrice > price) {
      const savings = comparePrice - price;

      // Update or create compare price
      if (comparePriceElement) {
        comparePriceElement.textContent = this.formatMoney(comparePrice);
        comparePriceElement.dataset.comparePrice = comparePrice;
      } else {
        const compareSpan = document.createElement('span');
        compareSpan.className = 'et-bundle__compare-price';
        compareSpan.textContent = this.formatMoney(comparePrice);
        compareSpan.dataset.comparePrice = comparePrice;
        priceElement.parentNode.appendChild(compareSpan);
      }

      // Update or create savings badge
      if (savingsBadge) {
        savingsBadge.textContent = `-${this.formatMoney(savings)}`;
        savingsBadge.dataset.savings = savings;
      } else {
        const savingsSpan = document.createElement('span');
        // savingsSpan.className = 'et-bundle__product-savings';
        // savingsSpan.textContent = `-${this.formatMoney(savings)}`;
        // savingsSpan.dataset.savings = savings;
        // priceRow.appendChild(savingsSpan);
      }
    } else {
      // Remove compare price and savings if no discount
      if (comparePriceElement) {
        comparePriceElement.remove();
      }
      if (savingsBadge) {
        savingsBadge.remove();
      }
    }

    // Update toggle data attributes
    const toggle = productItem.querySelector('.et-bundle__toggle-input');
    toggle.dataset.variantId = selectedOption.value;
    toggle.dataset.price = price;
    toggle.dataset.comparePrice = comparePrice;

    // Update totals
    this.updateTotals();
  }

  updateTotals() {
    let totalPrice = 0;
    let totalComparePrice = 0;

    this.toggles.forEach(toggle => {
      if (toggle.checked) {
        const price = parseFloat(toggle.dataset.price) || 0;
        const comparePrice = parseFloat(toggle.dataset.comparePrice) || 0;

        totalPrice += price;
        totalComparePrice += comparePrice || price;
      }
    });

    const savings = totalComparePrice - totalPrice;

    // Update display
    this.totalCurrent.textContent = this.formatMoney(totalPrice);

    if (totalComparePrice > totalPrice) {
      this.totalOriginal.textContent = this.formatMoney(totalComparePrice);
      this.totalOriginal.style.display = 'inline';

      const pathname = window.location.pathname;
      let savingsText = 'Bespaar';
      if (pathname.startsWith('/de/')) {
        savingsText = 'Sparen';
      } else if (pathname.startsWith('/fr/')) {
        savingsText = 'Économisez';
      }

      this.savingsBadge.textContent = `${savingsText} ${this.formatMoney(savings)}`;
      this.savingsBadge.style.display = 'inline-block';
    } else {
      this.totalOriginal.style.display = 'none';
      this.savingsBadge.style.display = 'none';
    }

    // Enable/disable add button
    this.addButton.disabled = totalPrice === 0;
  }

  async handleAddToCart() {
    // Immediately close any open panels (especially B2B panel)
    this.closeOtherPanels();

    const selectedItems = [];

    this.toggles.forEach(toggle => {
      if (toggle.checked) {
        selectedItems.push({
          id: toggle.dataset.variantId,
          quantity: 1
        });
      }
    });

    if (selectedItems.length === 0) {
      return;
    }

    // Show loading state
    this.addButton.disabled = true;
    this.addButton.classList.add('loading');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: selectedItems
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();

      // Add gift product if additional-product-widget exists
      await this.addGiftProduct();

      // Trigger cart update event
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));

      // Open cart drawer
      this.openCartDrawer();

      // Remove loading state and re-enable button
      this.addButton.classList.remove('loading');
      this.addButton.disabled = false;

    } catch (error) {
      console.error('Error adding to cart:', error);

      // Remove loading state and re-enable button on error
      this.addButton.classList.remove('loading');
      this.addButton.disabled = false;
    }
  }

  async addGiftProduct() {
    // Check if additional-product-widget exists on the page
    const giftWidget = document.querySelector('additional-product-widget');
    if (!giftWidget) {
      console.log('[Bundle] No gift widget found, skipping gift addition');
      return;
    }

    // Get the current gift product ID from the widget
    const giftProductId = giftWidget.dataset.currentGiftProductId;
    if (!giftProductId) {
      console.log('[Bundle] No gift product ID found');
      return;
    }

    console.log('[Bundle] 🎁 Adding gift product:', giftProductId);

    try {
      // First, clear any existing gifts (same as additional-product-widget does)
      await this.clearGiftsFromCart(giftWidget);

      // Wait a bit for cart to update
      await new Promise(resolve => setTimeout(resolve, 200));

      // Then add the new gift using cart/update.js (same method as widget)
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {
            [giftProductId]: 1
          }
        })
      });

      if (response.ok) {
        console.log('[Bundle] ✅ Gift product added successfully');
      } else {
        const error = await response.json();
        console.warn('[Bundle] ⚠️ Failed to add gift:', error);
      }
    } catch (error) {
      console.error('[Bundle] ❌ Error adding gift product:', error);
    }
  }

  async clearGiftsFromCart(giftWidget) {
    // Clear existing gifts before adding new one (mimics additional-product-widget behavior)
    try {
      const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
      if (!cartResponse.ok) return;

      const cart = await cartResponse.json();
      const productData = {};

      // Get all gift product options from dropdown
      const dropdown = giftWidget.querySelector('.js-gift-product-dropdown');
      if (dropdown) {
        const options = dropdown.querySelectorAll('option');
        options.forEach((option) => {
          if (option.value) {
            const giftVariantId = option.value;
            // Check if this gift is in cart
            const giftInCart = cart.items.find(item =>
              item.variant_id?.toString() === giftVariantId
            );
            if (giftInCart) {
              productData[giftVariantId] = 0;
            }
          }
        });
      }

      // Update cart to remove all gifts
      if (Object.keys(productData).length > 0) {
        await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: productData
          })
        });
        console.log('[Bundle] 🧹 Cleared old gifts from cart');
      }
    } catch (error) {
      console.error('[Bundle] Error clearing gifts:', error);
    }
  }

  openCartDrawer() {
    // Open cart drawer using theme's method
    const cartDrawer = document.getElementById('Cart-Drawer');

    if (cartDrawer && typeof cartDrawer.open === 'function') {
      // Use the theme's built-in open method
      cartDrawer.open();

      // Close other panels immediately after
      setTimeout(() => {
        this.closeOtherPanels();
      }, 10);
    } else {
      // Fallback: manually open ONLY the cart drawer
      const drawerElement = document.querySelector('.cart-drawer');
      if (drawerElement) {
        // Add open-cc class ONLY if cart drawer exists
        drawerElement.classList.add('active');
      }

      // Dispatch cart drawer open event
      document.documentElement.dispatchEvent(new CustomEvent('cart-drawer:open', {
        bubbles: true
      }));

      // Ensure other panels stay closed
      setTimeout(() => {
        this.closeOtherPanels();
      }, 10);
    }
  }

  closeOtherPanels() {
    // Aggressively close all non-cart side panels
    document.querySelectorAll('.side-panel').forEach(panel => {
      // Only keep cart drawer open
      if (!panel.classList.contains('cart-drawer')) {
        panel.classList.remove('active');
        // Force hide with inline style as extra measure
        panel.style.transform = '';
      }
    });

    // Remove all side panel specific body classes except cart
    document.body.classList.remove('open-cc--product');

    // Clear product drawer content if it exists
    const productDrawerContent = document.querySelector('#Product-Drawer-Content');
    if (productDrawerContent) {
      productDrawerContent.innerHTML = '';
    }

    // Specifically target and close problematic panels
    const b2bDrawer = document.getElementById('Product-B2B-Drawer');
    if (b2bDrawer) {
      b2bDrawer.classList.remove('active');
      b2bDrawer.style.visibility = 'hidden';
      setTimeout(() => {
        b2bDrawer.style.visibility = '';
      }, 100);
    }

    const productInfoDrawer = document.querySelector('.product-information-drawer');
    if (productInfoDrawer) {
      productInfoDrawer.classList.remove('active');
    }

    const sidePanelB2B = document.querySelector('.side-panel-b2b');
    if (sidePanelB2B) {
      sidePanelB2B.classList.remove('active');
    }
  }

  formatMoney(cents) {
    const amount = cents / 100;
    return new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount).replace('€', '').trim() + ',-';
  }
}

// Register custom element
if (!customElements.get('et-bundle')) {
  customElements.define('et-bundle', ETBundle);
}

